import type { GetStaticPaths, GetStaticProps } from "next"
import { type CategoryArchiveProps, getCategoryArchive } from "@/components/resources/data/archives"
import {
  isResourceCategory,
  RESOURCE_CATEGORIES,
} from "@/components/resources/data/markdown/categories"
import { SiteLayout } from "@/components/resources/layouts/site"
import { ResourceCategoryArchive } from "@/components/resources/templates/ResourceCategoryArchive"

const Archive = (props: CategoryArchiveProps) => <ResourceCategoryArchive {...props} />

Archive.getLayout = SiteLayout

export default Archive

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: Object.keys(RESOURCE_CATEGORIES).map((category) => ({ params: { category } })),
  fallback: false,
})

export const getStaticProps: GetStaticProps<CategoryArchiveProps, { category: string }> = async ({
  params,
}) => {
  const category = params?.category
  const props =
    category && isResourceCategory(category) ? await getCategoryArchive(category, 1) : null
  return props ? { props, revalidate: 180 } : { notFound: true }
}
